export default "__VITE_ASSET__XmjTI88D__"